import { Button } from "@altimateai/lego";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@altimateai/lego";
import { Badge } from "@altimateai/lego";
import { Card, CardContent, CardHeader } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { TestCase } from "../../services/evals";

interface TestCaseDetailModalProps {
  testCase: TestCase;
  onClose: () => void;
  onRunTest: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

export const TestCaseDetailModal: React.FC<TestCaseDetailModalProps> = ({
  testCase,
  onClose,
  onRunTest,
  onEdit,
  onDelete,
}) => {
  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="al-max-w-screen-xl al-max-h-[90vh] al-overflow-y-auto">
        <div
        >
          <DialogHeader>
            <DialogTitle>{testCase.name}</DialogTitle>
            {testCase.description && (
              <div
                className="al-text-sm al-text-gray-600 al-mt-2"
              >
                {testCase.description}
              </div>
            )}
          </DialogHeader>
        </div>

        <Stack direction="column" gap="md" className="al-mt-4">
          {testCase.tags && testCase.tags.length > 0 && (
            <div className="al-text-sm">
              <Stack direction="row" align="start" gap="xs">
                <span className="al-font-semibold al-text-cyan-700">Tags:</span>
                <Stack direction="row" className="al-flex-wrap al-gap-2">
                  {testCase.tags.map((tag, idx) => (
                    <Badge key={idx} variant="secondary" className="al-bg-cyan-100 al-text-cyan-700 al-border-cyan-200">
                      {tag}
                    </Badge>
                  ))}
                </Stack>
              </Stack>
            </div>
          )}
          <div className="al-text-sm al-text-gray-600">
            <Stack direction="row" align="center" gap="xs">
              <span className="al-font-semibold">Total Turns:</span>
              <span>{testCase.turns.length}</span>
            </Stack>
          </div>

          {testCase.turns.map((turn, index) => (
            <div
              key={index}
            >
              <Card>
                <CardHeader className="al-pb-3">
                  <div className="al-text-lg al-font-semibold">Turn {index + 1}</div>
                </CardHeader>
                <CardContent>
                  <Stack direction="column" gap="md">
                    <div
                    >
                      <div className="al-text-xs al-font-semibold al-text-orange-700 al-uppercase al-mb-2">User Message</div>
                      <div className="al-bg-orange-50 al-border al-border-orange-200 al-p-3 al-rounded-lg al-text-sm al-whitespace-pre-wrap">
                        {turn.user_message}
                      </div>
                    </div>

                    <div
                    >
                      <div className="al-text-xs al-font-semibold al-text-blue-700 al-uppercase al-mb-2">
                        Expected AI Response
                      </div>
                      <div className="al-bg-blue-50 al-border al-border-blue-200 al-p-3 al-rounded-lg al-text-sm al-whitespace-pre-wrap">
                        {turn.expected_ai_response}
                      </div>
                    </div>
                  </Stack>
                </CardContent>
              </Card>
            </div>
          ))}
        </Stack>

        <div
        >
          <DialogFooter className="al-mt-4">
            <Button
              onClick={onDelete}
              variant="outline" size="sm"
              className="al-text-red-600 hover:al-text-red-700 hover:al-bg-red-50 al-border-red-200"
            >
              Delete
            </Button>
            <div className="al-flex-1" />
            <Button onClick={onClose} variant="outline" size="sm">Close</Button>
            <Button onClick={onEdit} variant="outline" size="sm">Edit</Button>
            <Button size="sm" onClick={onRunTest}>Run Test</Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
};
